if (!customElements.get('accordion-links')) {
  class AccordionLinks extends HTMLElement {
    constructor() {
      super();
      this.onHashChange = () => this.open(this.findItem(window.location.hash));
      // Links to the current hash fire no hashchange
      this.onLinkClick = (event) => {
        const link = event.target.closest('a[href^="#tab-"]');
        if (link) this.open(this.findItem(link.getAttribute('href')));
      };
      // Theme editor, which scrolls to the selected block itself
      this.onBlockSelect = ({ target }) => {
        if (target.parentElement === this) this.open(target, false);
      };
    }

    connectedCallback() {
      this.onHashChange();
      window.addEventListener('hashchange', this.onHashChange);
      document.addEventListener('click', this.onLinkClick);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.onHashChange);
      document.removeEventListener('click', this.onLinkClick);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      clearTimeout(this.scrollTimeout);
    }

    findItem(hash) {
      return Array.from(this.querySelectorAll(':scope > .accordion')).find((item) => `#${item.id}` === hash);
    }

    open(item, scroll = true) {
      if (!item) return;

      const details = item.querySelector(':scope > details');
      details.open = true;
      details.querySelector(':scope > summary').setAttribute('aria-expanded', 'true');
      if (!scroll) return;

      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        // Same offset as scrollToElement in component-tabs.js, which stays untouched because collection tabs share it
        const top = item.getBoundingClientRect().top + window.scrollY - 150;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
      }, 100);
    }
  }

  customElements.define('accordion-links', AccordionLinks);
}
